module.exports = __webpack_public_path__ + "static/media/034-woman-8.299f9e91.svg";